module.exports = __webpack_public_path__ + "static/img/beco.1cd4191.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/beco.svg
// module id = 0eJM
// module chunks = 0